import React from 'react'

const Home = () => {
    return (
        <div className="w-full border-b border-solid border-stone-200">
            <h1 className="px-4 py-4 text-5xl sm:text-xl md:text-2xl lg:text-3xl font-bold">
                Welcome to Job Vacancy!!
            </h1>
            <h2 className='px-4 py-6 text-3xl sm:text-lg md:text-xl lg:text-2xl'>We can search 1000+ job is the best. Come on, what do you wait. Apply Now!!!</h2>

            <div className='px-4 py-2'>
                <img src='https://cdn.pixabay.com/photo/2016/12/19/10/16/hands-1917895__340.png' alt='' />
            </div>
        </div>
    )
}

export default Home;
